// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#root {
  min-height: 100%;
}

body {
  font-family: 'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #050816;
}

code,
.mono {
  font-family: 'JetBrains Mono', 'SFMono-Regular', Menlo, Monaco, Consolas, monospace;
}

.leaflet-container {
  width: 100%;
  height: 100%;
  background: #050816;
}

/* Dark tiles for the legacy map workspace */
.leaflet-tile-pane {
  filter: invert(1) hue-rotate(180deg) brightness(0.92) contrast(0.9) saturate(0.7);
}

.leaflet-control-attribution {
  background: rgba(5, 8, 22, 0.75) !important;
  color: #94a3b8 !important;
  font-size: 10px !important;
}

.leaflet-control-attribution a {
  color: #38bdf8 !important;
}

.leaflet-bar a {
  background: rgba(11, 18, 36, 0.92) !important;
  color: #f8fafc !important;
  border-color: rgba(56, 189, 248, 0.2) !important;
}

.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  background: rgba(11, 18, 36, 0.96) !important;
  color: #f8fafc !important;
  border: 1px solid rgba(56, 189, 248, 0.22);
  box-shadow: 0 18px 40px -18px rgba(0, 0, 0, 0.9);
}

.leaflet-popup-content {
  margin: 12px 14px !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE,iGAAiG;EACjG,mCAAmC;EACnC,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;;EAEE,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA,4CAA4C;AAC5C;EACE,iFAAiF;AACnF;;AAEA;EACE,2CAA2C;EAC3C,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;EAEE,6CAA6C;EAC7C,yBAAyB;EACzB,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody,\n#root {\n  min-height: 100%;\n}\n\nbody {\n  font-family: 'Outfit', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: #050816;\n}\n\ncode,\n.mono {\n  font-family: 'JetBrains Mono', 'SFMono-Regular', Menlo, Monaco, Consolas, monospace;\n}\n\n.leaflet-container {\n  width: 100%;\n  height: 100%;\n  background: #050816;\n}\n\n/* Dark tiles for the legacy map workspace */\n.leaflet-tile-pane {\n  filter: invert(1) hue-rotate(180deg) brightness(0.92) contrast(0.9) saturate(0.7);\n}\n\n.leaflet-control-attribution {\n  background: rgba(5, 8, 22, 0.75) !important;\n  color: #94a3b8 !important;\n  font-size: 10px !important;\n}\n\n.leaflet-control-attribution a {\n  color: #38bdf8 !important;\n}\n\n.leaflet-bar a {\n  background: rgba(11, 18, 36, 0.92) !important;\n  color: #f8fafc !important;\n  border-color: rgba(56, 189, 248, 0.2) !important;\n}\n\n.leaflet-popup-content-wrapper,\n.leaflet-popup-tip {\n  background: rgba(11, 18, 36, 0.96) !important;\n  color: #f8fafc !important;\n  border: 1px solid rgba(56, 189, 248, 0.22);\n  box-shadow: 0 18px 40px -18px rgba(0, 0, 0, 0.9);\n}\n\n.leaflet-popup-content {\n  margin: 12px 14px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
